import { useReportContextToDevPanel } from 'components/App/DevPanel/hooks'
import { useAppSelector } from 'hooks/reduxHooks'
import type { PropsWithChildren } from 'react'
import React from 'react'
import { initialGeoState } from 'reducers/geo'

const GeoContext = React.createContext<App.GeoState>(initialGeoState)

export function GeoProvider(props: PropsWithChildren) {
  const geo = useAppSelector((state) => state.geo)

  useReportContextToDevPanel('GeoContext', geo)

  return <GeoContext.Provider value={geo}>
    {props.children}
  </GeoContext.Provider>
}

export default GeoContext
